<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.billing">
  <app-popup-header title="{{localService.languageContent.billing.deleted_header}}"></app-popup-header>
  <div class="modal-body" *ngIf="items" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <table style="width:100%;line-height:25px;">
      <ng-template ngFor let-item [ngForOf]="items">
        <tr>
          <td colspan="2">
            <span class="en button" (click)="localService.showSummary(item.v8,3)">{{item.key}}&nbsp;-&nbsp;</span>
            <span [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
          </td>
        </tr>
        <tr *ngIf="item.v3 != ''">
          <td colspan="2">{{localService.languageContent.billing.deleted_reason}}&nbsp;:&nbsp;{{item.v3}}</td>
        </tr>
        <tr>
          <td class="deleted_name">
            <span class="en">&nbsp;-&nbsp;</span>
            <span [ngClass]="localService.getLanguageCode(item.v7)">{{item.v6}}</span>
          </td>
          <td class="en deleted_time">{{item.v5 | localDate}}</td>
        </tr>
        <tr>
          <td colspan="2">
            &nbsp;
          </td>
        </tr>
      </ng-template>
    </table>
  </div>
</div>
